import type { FC } from 'react';
import React, { useState } from 'react';
import { MdOutlineClose } from 'react-icons/md';

import styles from './index.module.scss';

export type ImageElementProps = {
  image: string;
};

const ImageElement: FC<ImageElementProps> = ({ image }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles[open ? 'imageWrapper--open' : 'imageWrapper']}>
      {open && (
        <div className={styles.mask}>
          <button className={styles.closeButton} onClick={() => setOpen(false)}>
            <MdOutlineClose />
          </button>
        </div>
      )}
      <img
        className={styles.image}
        src={image}
        alt="feedback message image"
        onClick={() => setOpen(true)}
      />
    </div>
  );
};

export default ImageElement;
